import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UnsubscribeComponent } from "../../../../generals/Components";
import { takeUntil } from "rxjs/operators";
import { AdminModuleDetail, ModuleProductSearchIndexerConfig } from "../../../../interfaces/interfaces";
import { ApiService } from "../../../../services/api.service";

@Component({
    selector: 'app-productsearchindexermodule',
    templateUrl: './productsearchindexermodule.component.html',
    styleUrls: ['./productsearchindexermodule.component.scss']
})
export class ProductSearchIndexerModuleComponent extends UnsubscribeComponent implements OnInit {

    @Input() module: AdminModuleDetail<ModuleProductSearchIndexerConfig> = null;
    indexProductBrand: boolean = false;
    indexProductCode: boolean = false;

    @Output() inited: EventEmitter<boolean> = new EventEmitter();
    @Output() configChanged: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private apiService: ApiService
    ) {
        super();
    }

    ngOnInit(): void {
        this.inited.emit(true);
        this.indexProductBrand = this.module.config.indexProductBrand;
        this.indexProductCode = this.module.config.indexProductCode;
    }

    configChangedEvent(): void {
        this.configChanged.emit(true);
    }

    saveConfig(): void {
        const config: ModuleProductSearchIndexerConfig = {
            indexProductBrand: this.indexProductBrand,
            indexProductCode: this.indexProductCode
        };
        this.apiService.saveModuleConfig(this.module.id, config).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.configChanged.emit(false);
        });
    }
}